/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1CatReportState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_CAT_REPORT_STATE_ENTITY_NAME = 'ixc.tradereporting.v1.CatReport';
export const ixcTradereportingV1CatReportStateEntity = new schema.Entity<IxcTradereportingV1CatReportState>(IXC_TRADEREPORTING_V1_CAT_REPORT_STATE_ENTITY_NAME, {}, { idAttribute: 'reportId' });

